import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { CourseResponse } from "../models/course.model";

export namespace CourseActions {
    @logDispatcher
    export class GetCourses {
      static readonly type = '[Course] GetCourses';
      constructor(public schoolId?: number) {}
    }
  
    @logDispatcher
    export class GetCoursesSuccess {
      static readonly type = '[Course] GetCoursesSuccess';
      constructor(public courses: CourseResponse[]) {}
    }
  
    @logDispatcher
    export class Error {
      static readonly type = '[Course] Error';
      constructor(public error: any) {}
    }
}